export default __webpack_public_path__ + "static/media/EM1810.34I-42024_-25184_0.391f244c.jpg";